import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getProducts, saveImage, uploadImages } from '@/api/products';
import { getQuery } from '@/utils';
let ProductImages = class ProductImages extends Vue {
  constructor() {
    super(...arguments);
    this.uploadedImages = [];
    this.statusFilter = 'all';
  }
  // Computed property for filtered images
  get filteredImages() {
    if (this.statusFilter === 'all') {
      return this.uploadedImages;
    }
    return this.uploadedImages.filter(img => img.status === this.statusFilter);
  }
  // Count images by status
  countByStatus(status) {
    return this.uploadedImages.filter(img => img.status === status).length;
  }
  // handle files added via el-upload
  handleChange(file, fileList) {
    const raw = file.raw || file;
    const exists = this.uploadedImages.find(f => f.name === raw.name && f.size === raw.size);
    if (exists) return;
    const reader = new FileReader();
    reader.onload = async e => {
      const url = e.target.result;
      const newRow = {
        uid: file.uid || `${Date.now()}-${Math.random()}`,
        name: raw.name,
        id: raw.id,
        size: raw.size,
        url,
        status: 'ready',
        progress: 0,
        productName: null,
        raw
      };
      this.uploadedImages.push(newRow);
      try {
        const resp = await getProducts(getQuery({
          catalogueCode: raw.name.replace(/\.[^/.]+$/, ''),
          filter: {
            catalogueCode: '$eq'
          }
        }));
        console.log('response', resp);
        if (resp && resp.length > 0) {
          // Show all matching product names
          newRow.productName = resp.length > 1 ? `${resp.map(p => p.name).join(', ')} (${resp.length} products)` : resp[0].name;
          // Store all matching IDs for upload
          newRow.productIds = resp.map(p => p.id);
          newRow.id = resp[0].id; // Keep first ID for display
        }
      } catch (err) {
        // ignore - endpoint may not exist yet
      }
    };
    reader.readAsDataURL(raw);
  }
  beforeRemove(file, fileList) {
    // allow removal (el-upload will call this)
    return true;
  }
  removeImage(index, row) {
    // Find the actual index in uploadedImages array
    const actualIndex = this.uploadedImages.findIndex(img => img.uid === row.uid);
    if (actualIndex !== -1) {
      this.uploadedImages.splice(actualIndex, 1);
    }
  }
  statusToTag(status) {
    switch (status) {
      case 'ready':
        return 'info';
      case 'uploading':
        return 'warning';
      case 'uploaded':
        return 'success';
      case 'failed':
        return 'danger';
      default:
        return 'info';
    }
  }
  formatSize(bytes) {
    if (!bytes) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  }
  // Placeholder upload - replace with actual API call
  async uploadOne(row) {
    if (!row.raw) return;
    row.status = 'uploading';
    row.progress = 0;
    try {
      const productIds = row.productIds || [row.id];
      if (!productIds.length || !productIds[0]) {
        row.status = 'failed';
        this.$message({
          message: `No product found for ${row.name}`,
          type: 'error'
        });
        return;
      }
      // Step 1: Upload image to S3
      row.progress = 30;
      const formData = new FormData();
      formData.append('file', row.raw);
      formData.append('productId', productIds[0].toString());
      const uploadResult = await uploadImages(formData);
      const s3Url = uploadResult;
      row.progress = 60;
      // Step 2: Update all matching products with the S3 URL
      const updatePromises = productIds.map(async productId => await saveImage({
        productId,
        image: s3Url
      }));
      await Promise.all(updatePromises);
      row.progress = 100;
      row.status = 'uploaded';
      const productCount = productIds.length;
      this.$message({
        message: `${row.name} uploaded and assigned to ${productCount} product${productCount > 1 ? 's' : ''}`,
        type: 'success'
      });
    } catch (err) {
      console.error('Upload error:', err);
      row.status = 'failed';
      row.progress = 0;
      this.$message({
        message: `Upload failed: ${row.name}`,
        type: 'error'
      });
    }
  }
  async uploadAll() {
    for (const row of this.uploadedImages) {
      if (row.status === 'ready' || row.status === 'failed') {
        // eslint-disable-next-line no-await-in-loop
        await this.uploadOne(row);
      }
    }
  }
};
ProductImages = __decorate([Component], ProductImages);
export default ProductImages;